import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

const initFancybox = () => {
    Fancybox.bind("[data-fancybox]", {
        // Close when clicking outside the content
        closeExisting: true,

        // Keyboard navigation
        keyboard: {
            Escape: "close",
            Delete: "close",
            Backspace: "close",
            PageUp: "next",
            PageDown: "prev",
            ArrowUp: "prev",
            ArrowDown: "next",
            ArrowRight: "next",
            ArrowLeft: "prev",
        },


        // Image behavior
        Images: {
            zoom: true,
        },

        // Thumbnails
        Thumbs: {
            type: "classic",
        },
    });
};

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initFancybox);
} else {
    initFancybox();
}